<mat-card appearance="outlined" class="syn-card" fxFlex="1 1 100%">
    <div fxLayout="column" fxLayoutAlign="space-around stretch" class='must-select-wrapper'>
        <span class="must-select-text must-animation">Veuillez sélectionner un filtre ou <br>effectuer une recherche pour afficher les résultats</span>
        <div fxLayout="row" class="must-detail-wrapper">
            <div class="main-round-graphic must-animation main-round">
                <mat-icon svgIcon="layers-search-outline" class="search-round-icon must-animation"></mat-icon>
            </div>
            <div class="moving-circles must-animation">
                <img src="assets/img/synapps-logo-dismem-1.png" class="logo-dis-1 must-animation"/>
                <img src="assets/img/synapps-logo-dismem-1.png" class="logo-dis-1-bis must-animation"/>
            </div>
            <img src="assets/img/synapps-logo-dismem-2.png" class="logo-dis-2 must-animation"/>
        </div>
    </div>
</mat-card>